import { useMemo } from 'react';

/**
 * Возвращает undefined, если переданная строка содержит только числовое значение.
 * Иначе возвращает исходную строку в нижнем регистре.
 * Необходимо, чтобы на сниппете не отображались некорректно заполненные данные.
 */
export const useConstructionTime = (constructionTime: string | undefined) => {
  return useMemo(() => {
    if (!constructionTime) {
      return;
    }

    if (Number.isNaN(+constructionTime)) {
      return constructionTime.toLocaleLowerCase();
    }

    return;
  }, [constructionTime]);
};
